export default __webpack_public_path__ + "static/media/01AW1JUL66.ba47a3d7.jpg";